import { useState } from 'react'

import { Box, IconButton, Snackbar, TextField } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClipboard, faClipboardCheck } from '@fortawesome/pro-light-svg-icons'

type propTypes = {
  value: string
  label: string
}

export const CopyToClipboard = ({ value, label }: propTypes) => {
  const [copied, setCopied] = useState(false)

  const copyToClipboard = () => {
    if (value) {
      navigator.clipboard.writeText(value)
      setCopied(true)
      setTimeout(() => {
        setCopied(false)
      }, 3000)
    }
  }
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        gridGap={8}
      >
        <Box
          flexGrow={1}
          width="100%"
        >
          <TextField
            value={value}
            inputProps={{ readOnly: true }}
            fullWidth
            multiline
            maxRows={5}
            variant="outlined"
            color="primary"
            label={label}
          ></TextField>
        </Box>
        <IconButton
          color="primary"
          disableFocusRipple={true}
          onClick={() => copyToClipboard()}
          aria-label="copy to clipboard"
        >
          {copied ? <FontAwesomeIcon icon={faClipboardCheck} /> : <FontAwesomeIcon icon={faClipboard} />}
        </IconButton>
      </Box>
      {copied && (
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={copied}
        >
          <Alert
            severity="success"
            icon={<FontAwesomeIcon icon={faClipboardCheck} />}
          >
            Copied to clipboard
          </Alert>
        </Snackbar>
      )}
    </>
  )
}
